import { useLoginPrompt } from '@pm2/react-utils';
import { ResourceLink } from '@pm2/ui-components';
import { useUserIdentityState } from '@provider/user-identity';
import { OpenInternalIcon, OpenExternalIcon, OpenDownloadIcon, OpenIcon } from '@ui/kit/icons';
import { overlayCls, labelCls, iconCls } from './overlay.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Overlay(props) {
  const {
    label,
    icon
  } = getOverlayContent(props.resource);
  const isLoggedIn = useUserIdentityState(state => !!state.user);
  const triggerLoginPrompt = useLoginPrompt();
  return /*#__PURE__*/jsxs("div", {
    className: overlayCls,
    children: [isLoggedIn ? /*#__PURE__*/jsx(ResourceLink, {
      "data-resource-trigger": true,
      resource: props.resource,
      className: labelCls,
      onClick: props.onLinkClick,
      children: label
    }) : /*#__PURE__*/jsx("button", {
      "data-resource-trigger": true,
      className: labelCls,
      onClick: triggerLoginPrompt,
      children: label
    }), /*#__PURE__*/jsx("div", {
      className: iconCls,
      children: icon
    })]
  });
}
function getOverlayContent(resource) {
  switch (resource.kind) {
    case "Document":
      return {
        label: "Download",
        icon: /*#__PURE__*/jsx(OpenDownloadIcon, {
          height: 27
        })
      };
    case "ExternalLink":
      return {
        label: "Nyt vindue",
        icon: /*#__PURE__*/jsx(OpenExternalIcon, {
          height: 24
        })
      };
    case "InternalLink":
      return {
        label: "Samme vindue",
        icon: /*#__PURE__*/jsx(OpenInternalIcon, {
          height: 25
        })
      };
  }
  switch (resource.target) {
    case "Page":
      return {
        label: "Samme vindue",
        icon: /*#__PURE__*/jsx(OpenInternalIcon, {
          height: 25
        })
      };
    case "NewWindow":
      return {
        label: "Nyt vindue",
        icon: /*#__PURE__*/jsx(OpenExternalIcon, {
          height: 24
        })
      };
    case "Lightbox":
    default:
      return {
        label: "Åbn",
        icon: /*#__PURE__*/jsx(OpenIcon, {
          height: 24
        })
      };
  }
}

export { Overlay };
//# sourceMappingURL=overlay.js.map
